export default "__VITE_ASSET__a526e06b__"